import { useReleaseCheck } from "../../../lib/hooks/useReleaseCheck";
import { RefreshCcw } from "lucide-react";

interface ReleaseNotificationProps {
	appInitializedAt: string | null;
	app: "dentlab" | "dentconnect";
}

export const ReleaseNotification: React.FC<ReleaseNotificationProps> = ({
	appInitializedAt,
	app,
}) => {
	const { hasNewRelease } = useReleaseCheck(appInitializedAt, app);

	if (!hasNewRelease) return null;

	const handleReload = () => {
		window.location.reload();
	};

	return (
		<div
			className="bg-blue-50 border-b border-blue-200 px-4 py-3 rounded-md mx-2 my-1"
			role="alert"
			aria-label="Neue Version verfügbar"
			data-testid="release-notification"
		>
			<div className="flex items-center justify-center gap-3 max-w-7xl mx-auto">
				<RefreshCcw className="h-4 w-4 text-blue-600 flex-shrink-0" />
				<span className="text-sm text-blue-900 font-medium">
					Eine neue Version der App ist verfügbar.
				</span>
				<button
					onClick={handleReload}
					className="bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium px-4 py-1.5 rounded-md transition-colors whitespace-nowrap"
					aria-label="App aktualisieren"
					data-testid="reload-button"
				>
					Aktualisieren
				</button>
			</div>
		</div>
	);
};
